module.exports = __webpack_public_path__ + "static/TM1-Politica-de-Privacidade-e-Protecao-de-Dados-Pessoais-62d9255363d12dcac57b55c6155caed6.pdf";